module.exports = __webpack_public_path__ + "img/exp_summoner_thum.9608be13.png";